import { FeatheredImage } from "../../FeatheredImage";

const A = "/brand";
const IMG = `${A}/spark-garden-laptop.jpg`;
const ALT = "Lara writing in her notebook on a garden bench, laptop resting on her lap.";

export function MaybeSoundsFamiliar() {
  return (
    <section data-testid="maybe-sounds-familiar-section" className="relative overflow-hidden bg-white">
      <div className="max-w-7xl mx-auto px-6 md:px-10 pt-[47px] md:pt-[61px] lg:pt-[77px] pb-[17px] md:pb-[27px] reveal">
        <div className="max-w-3xl">
          <h2 className="font-display text-4xl md:text-5xl lg:text-6xl leading-[1.08] tracking-tight text-[#1C1917]">
            Maybe This Sounds Familiar&hellip;
          </h2>
        </div>
      </div>

      <div className="relative w-full overflow-hidden reveal pb-[38px] lg:pb-0">
        {/* Desktop image half-band — right side, feathering into white on the inner edge */}
        <div className="hidden lg:block absolute inset-y-0 right-0 w-[52%]">
          <FeatheredImage
            src={IMG}
            alt={ALT}
            objectPosition="52% 10%"
            featherLeft={44}
            featherTop={12}
            featherBottom={12}
            className="absolute inset-0"
          />
        </div>

        {/* Mobile image stacked on top */}
        <div className="lg:hidden relative w-full aspect-[4/3] mb-[26px]">
          <FeatheredImage
            src={IMG}
            alt={ALT}
            objectPosition="52% 6%"
            featherBottom={18}
            className="absolute inset-0"
          />
        </div>

        <div className="relative z-[2] max-w-7xl mx-auto px-6 md:px-10 flex items-center lg:min-h-[500px]">
          <div className="w-full lg:w-1/2">
            <div className="space-y-3 max-w-[460px]">
              <p className="font-display text-2xl md:text-3xl text-[#57534E] italic leading-snug">
                &ldquo;I&rsquo;ll do it this weekend.&rdquo;
              </p>
              <p className="font-display text-2xl md:text-3xl text-[#57534E] italic leading-snug">
                &ldquo;I just need a free afternoon.&rdquo;
              </p>
              <p className="font-display text-2xl md:text-3xl text-[#57534E] italic leading-snug">
                &ldquo;I work better when someone else is working too.&rdquo;
              </p>
              <p className="font-display text-2xl md:text-3xl text-[#57534E] italic leading-snug">
                &ldquo;I know exactly what I need to do. I just haven&rsquo;t done it.&rdquo;
              </p>
              <p className="text-lg md:text-xl text-[#57534E] leading-relaxed pt-3">
                If you found yourself nodding&hellip;
              </p>
              <p className="font-display text-2xl md:text-3xl text-[#159E9A] leading-snug">
                You&rsquo;re probably in the right place.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
